import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { fetchNextInfoBlockNewsItem } from '../../actions/header';
import { HeaderInfoBlock, HeaderInfoBlockProps } from '../../components/HeaderInfoBlock/HeaderInfoBlock';
import { State } from '../../typings/state';

export type StateProps = Pick<HeaderInfoBlockProps, 'isInfoBlockLoading' | 'news' | 'hasNewItems'>;

interface OwnProps {
    cls?: string;
}

export type DispatchProps = Pick<HeaderInfoBlockProps, 'fetchNextInfoBlockNewsItem'>;

export const mapStateToProps = (state: State): StateProps => {
    const {
        header: {
            isInfoBlockLoading,
            infoBlockData: { news, hasNewItems }
        }
    } = state;

    return {
        news,
        isInfoBlockLoading,
        hasNewItems
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        fetchNextInfoBlockNewsItem: () => {
            dispatch(fetchNextInfoBlockNewsItem());
        }
    };
};

export const HeaderInfoBlockContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(HeaderInfoBlock);
